
$(function () {

   
    var prefix = "";
   // var oper ='@ViewContext.RouteData.Values["oper"].ToString()';
    if (location.hostname === "localhost") { prefix=""}
    else {prefix=window.location.pathname.split("/")[1];}

    var strUrl= ""
    if (prefix === "") {
        strUrl = window.location.protocol + "//" + window.location.host + "/" + window.app.currentLanguage() + "/" + "home/HasUserAlerts"
    }
    else {
        strUrl = window.location.protocol + "//" + window.location.host + "/" + prefix + "/" + window.app.currentLanguage() + "/" + "home/HasUserAlerts"
    }

    if (window.location.pathname !== undefined && window.location.pathname != null) {
        strUrl += "?pathName=" + encodeURIComponent(window.location.pathname)
    }

    if ($(".inboxlink").length > 0) {
        $.getJSON(
            strUrl,
            function (data) {
                $(".inbox-spinner").remove();

                try {

                    if (data && data.hasNew && data.hasNew === true) {
                        $(".inboxlink span")
                            .html(data.count)
                            .removeClass("badge-danger")
                            .addClass("badge-info")
                            .show();
                 
                    } else if (data && data.count >= 0) {
                                                    // no badge if nothing new
                    }

                    //if (checkalertroutes && data && data.warnings && data.warnings.length > 0) {
                    //    var warnings = data.warnings;
                    //    // If we have warnings to show, find the container for the warnings.
                    //    var container = $("<div class='warning-container'></div>");
                    //    container.insertAfter(".body-content hr:first");
                    //    if (container.length > 0) {
                    //        for (var i = 0; i < warnings.length; i++) {
                    //            var warning = warnings[i];

                    //            var warningPeriods = "";

                    //            // If the warning has periods associated with it, build a list of those periods here.
                    //            if (warning.warningMessagePeriods && warning.warningMessagePeriods.length > 0) {
                    //                warningPeriods = "<ul>"
                    //                for (var j = 0; j < warning.warningMessagePeriods.length; j++) {
                    //                    var period = warning.warningMessagePeriods[j];
                    //                    // the dateJoinString is a translated string that comes from the controller.
                    //                    warningPeriods += "<li>" + period.start + " " + warning.dateJoinString + " " + period.end + "</li>"
                    //                }
                    //                warningPeriods += "</ul>"
                    //            }

                    //            var button = "";

                    //            // If there's a warning button specified, build it here.
                    //            if (warning.warningButton && warning.warningButtonUri) {
                    //                button = "<div class='text-center'><a class='btn btn-primary' href='" + warning.warningButtonUri + "'>" +
                    //                    warning.warningButton + "</a></div>";
                    //            }

                    //            // Create the warning div and append it to the warning container.
                    //            var appendItem = "<div class='alert alert-warning mb-2'><div class='mb-3'>" + warning.warningText + "</div>" + warningPeriods + button + "</div>"

                    //            container.append(appendItem);                            
                    //        }
                    //    }
                    //}

                   //$(".body-content").fadeIn(50);
                } catch (e) {

                    //$(".body-content").fadeIn(50); 
                }
            } // function data
        );
    }

    
});
